import React, { useState, useRef, useEffect } from 'react'
import ReactGA from 'react-ga'
import Cookies from 'js-cookie'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import VisibilitySensor from 'react-visibility-sensor'

import l10n from '../i18n/I18N'
import Lottie from 'react-lottie'
import { useStateValue } from '../../services/state/StateProvider'
import { convertUrlToWebp, tokenizer } from '../../services/utils'
import { config } from './../Init/Init'

import './styles/tout.scss'

function ToutContentAbsolute(props) {
  const [backgroundWidth, setBackgroundWidth] = useState('100%')
  const toutParentElement = useRef(null)

  function getAnimationPosition(position) {
    if (position === 'left') {
      return 'xMinYMid slice'
    } else if (position === 'right') {
      return 'xMaxYMid slice'
    } else {
      return 'xMidYMid slice'
    }
  }

  const colorStyle = () => {
    if (props.data.colors) {
      if (props.data.colors.split('),').length > 1) {
        return {
          backgroundImage: `linear-gradient(${props.data.colors})`
        }
      } else {
        return {
          backgroundColor: `${props.data.colors}`
        }
      }
    }
  }

  const gaMetrics = data => {
    // record tout click event in GA
    if (Cookies.get('acceptCookies')) {
      ReactGA.event({
        category: 'Banner CTA',
        action: 'A User clicked on the Banner CTA and opened: ' + data.url,
        label: 'Banner Call To Action'
      })
    }
  }

  const state = useStateValue()
  let casino
  let animOptions = {}
  // State might not be ready yet.
  if (state) {
    casino = state[0].casino
  }

  const animJson = () => {
    let storedAnim = casino?.animations[props.data.anim]
    if (storedAnim) {
      for (let i = 0; i < storedAnim.assets.length; i++) {
        if (storedAnim.assets[i].u) {
          storedAnim.assets[i].u = `${process.env.PUBLIC_URL}/content/images/${storedAnim.nm}/`
        }
      }
    }
    return storedAnim
  }

  if (props.data.anim) {
    animOptions = {
      loop: true,
      autoplay: true,
      animationData: animJson(),
      rendererSettings: {
        preserveAspectRatio: getAnimationPosition(props.data.animationAlign)
      }
    }
  }

  useEffect(() => {
    if (props.data.url) {
      let url = process.env.PUBLIC_URL + props.data.url
      let bgImage = document.createElement('img')
      bgImage.src = url
      bgImage.addEventListener('load', event => {
        // we want the element containing the background image to match the width
        // The area of the popup should be defined so click events will make sense with respect to the image
        if (toutParentElement.current && toutParentElement.current.clientHeight)
          setBackgroundWidth(
            Math.round((bgImage.width * toutParentElement.current.clientHeight) / bgImage.height).toString() + 'px'
          )
      })
    }
  }, [props.data.url])

  if (props.type === 'video') {
    return (
      <div
        className={`tout-layer h-1/1 ov-h pos-a r-0 b-0 l-0 t-0 w-1/1 ${props.data.classes ? props.data.classes : ''}`}
        id={props.id ? props.id : null}
      >
        <video
          className="l-50/100 mih-1/1 miw-1/1 pos-a t-50/100"
          defaultmuted="true"
          autoPlay
          playsInline
          loop
          muted
          style={{
            transform: `translate(-50%, -50%)`
          }}
        >
          <source src={process.env.PUBLIC_URL + props.data.url} type="video/mp4" />
        </video>
      </div>
    )
  } else if (props.type === 'image') {
    let url = process.env.PUBLIC_URL + props.data.url
    if (window.Modernizr.webp && props.data.hasWebp) {
      url = convertUrlToWebp(url)
    }

    let toutLayerStyle =
      props.isBanner && config.enableBlurredBackground
        ? { pointerEvents: 'all', backgroundImage: `url(${url})`, backgroundRepeat: 'no-repeat' }
        : props.isBanner
        ? { pointerEvents: 'all', backgroundImage: `url(${url})`, backgroundRepeat: 'unset' }
        : {
            pointerEvents: 'all',
            backgroundImage: `url(${url})`,
            backgroundRepeat: 'no-repeat',
            width: `min(${backgroundWidth}, 100%)`,
            margin: 'auto'
          }

    return (
      <div ref={toutParentElement}>
        {props.isBanner && config.enableBlurredBackground && (
          <div
            className="banner-overlay"
            style={{
              backgroundImage: `url(${url})`
            }}
          ></div>
        )}
        <div
          className={`tout-layer ${
            props.isBanner && config.enableBlurredBackground
              ? 'tout-layer-contain'
              : props.isBanner
              ? 'bgs-cov'
              : 'bgs-auto'
          } dis-f fxd-c jc-c mih-1/1 ov-h r-0 b-0 l-0 t-0 pos-a w-1/1 ${props.data.classes ? props.data.classes : ''}`}
          id={props.id ? props.id : null}
          style={toutLayerStyle}
        ></div>
      </div>
    )
  } else if (props.type === 'animation') {
    return (
      <div
        className={`tout-layer mh-a r-0 l-0 pos-a w-1/1 b-0 t-0 ${props.data.classes ? props.data.classes : ''}`}
        id={props.id ? props.id : null}
      >
        <VisibilitySensor>{({ isVisible }) => <Lottie options={animOptions} isPaused={!isVisible} />}</VisibilitySensor>
      </div>
    )
  } else if (props.type === 'video-link') {
    return (
      <Link
        to="#"
        className={`tout-layer h-1/1 ov-h pos-a r-0 b-0 l-0 t-0 w-1/1 ${props.data.classes ? props.data.classes : ''}`}
        id={props.id ? props.id : null}
        onClick={() => {
          gaMetrics(props.data)
          if (props.onAction) {
            props.onAction({
              type: 'ctaClicked',
              action: 'PlayVideo',
              url: props.data.url,
              ctaNumber: props.data.ctaNumber
            })
          }
        }}
      ></Link>
    )
    // TODO: abstract 'close' into a tout action handler when new actions are requested
  } else if (props.type === 'link' || props.type === 'close') {
    return (
      <Link
        to={l10n.localizeUrl(props.data.url)}
        className={`tout-layer h-1/1 ov-h pos-a r-0 b-0 l-0 t-0 w-1/1 ${props.data.classes ? props.data.classes : ''}`}
        id={props.id ? props.id : null}
        onClick={() => {
          gaMetrics(props.data)
          if (props.onAction) {
            props.onAction({
              type: 'ctaClicked',
              url: props.data.url,
              ctaNumber: props.data.ctaNumber
            })
          }
        }}
      ></Link>
    )
  } else if (props.type === 'button') {
    return (
      <button
        className={`tout-layer h-1/1 ov-h pos-a r-0 b-0 l-0 t-0 w-1/1 ${props.data.classes ? props.data.classes : ''}`}
        id={props.id ? props.id : null}
        onClick={() => {
          if (props.onAction) {
            props.onAction({
              type: 'ctaClicked',
              action: props.data.action,
              ctaNumber: props.data.ctaNumber
            })
          }
        }}
      >
        {props.data.text}
      </button>
    )
  } else if (props.type === 'color') {
    return (
      <div
        className={`tout-layer mh-a r-0 l-0 pos-a w-1/1 b-0 t-0 ${props.data.classes ? props.data.classes : ''}`}
        id={props.id ? props.id : null}
        style={colorStyle()}
      ></div>
    )
  } else {
    return (
      <div className="tout-layer" id={props.id ? props.id : null}>
        {tokenizer(l10n.t['lobby.slideerror'], {
          '{type}': props.type
        })}
      </div>
    )
  }
}

ToutContentAbsolute.propTypes = {
  data: PropTypes.object.isRequired
}

export default ToutContentAbsolute
